import React from 'react';
import { useDeals } from '~/hooks/useDeals';
import Loader from '~/components/common/parts/loading/Loading';
import { BreadcrumbItem } from '~/components/common/parts/breadcrumb/Breadcrumbs';
import { PATH as DEALS_PATH } from '~/pages/deals';
import { PATH as DEAL_PATH } from '~/pages/deals/[id]';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import { DealLayout } from '~/components/common/layouts/deals/DealLayout';
import { DealCard } from '~/components/common/deals/show/deal_card/DealCard';
import { DealInspectionClientCard } from '~/components/common/deals/show/inspection_card/DealInspectionClientCard';
import { DealConstructionScheduleClientCard } from '~/components/common/deals/show/construction_card/DealConstructionScheduleClientCard';
import { DealOriginVendorClientCard } from '~/components/common/deals/show/vendor_card/DealOriginVendorClientCard';
import { useIdQueryHandler } from '~/hooks/useIdQueryHandler';
import { DealRepairCard } from '~/components/common/deals/show/repair_card/DealRepairCard';
import { DealVendorNoteCard } from '~/components/common/deals/show/deal_card/DealVendorNoteCard';

export const Page: React.FC = () => {
  const id = useIdQueryHandler();
  const { data: deal, mutate: mutateDeal, isLoading } = useDeals().show(id);
  const handleMutate = React.useCallback(async () => {
    mutateDeal && (await mutateDeal());
  }, [mutateDeal]);
  if (isLoading || deal === null) {
    return <Loader isLoading />;
  }
  const breadcrumbItems: BreadcrumbItem[] = [
    { path: DEALS_PATH, caption: '案件一覧', active: false },
    { path: DEAL_PATH(deal.id), caption: '案件詳細', active: false },
    { path: null, caption: '案件内容', active: true }
  ];
  return (
    <DefaultV2>
      <DealLayout
        breadcrumbItems={breadcrumbItems}
        deal={deal}
        isVendor={false}
        noBackground
      >
        <DealOriginVendorClientCard />
        <DealVendorNoteCard deal={deal} />
        <DealCard deal={deal} />
        <DealRepairCard
          companyType="client"
          deal={deal}
          handleMutate={handleMutate}
        />
        <DealInspectionClientCard />
        <DealConstructionScheduleClientCard />
      </DealLayout>
    </DefaultV2>
  );
};
